<template>
  <section id="tour_booking_submission" class="section_padding bg-secondary-subtle">
    <div class="container" v-if="isDataLoaded">
      <div class="row mx-auto d-flex flex-column align-items-center">
        <div class="col-lg-6">
          <div class="tou_booking_form_Wrapper">
            <div class="tour_booking_form_box mb-4">
              <div class="booking_success_arae">
                <div class="booking_success_img">
                  <img :src="require(`@/assets/img/icon/${image}.png`)" alt="img" />
                </div>
                <div class="booking_success_text">
                  <h3 v-if="!countdownExpired">{{ paymentMessage != '' ? paymentMessage : $t("successful_order") }}</h3>
                  <h3 v-if="countdownExpired">{{ $t("reservation_expired") }}</h3>
                  <h6 >
                    {{ $t("message_order") }}:
                    {{ booking_data.leadGuest.contact.email }}
                  </h6>
                  <h6 v-if="booking_data.payable">{{ $t("payment_status") }}: <strong>{{ booking_data.payStatus
                      }}</strong></h6>
                  
                  <br />
                </div>
              </div>
              <div class="text-center">
                <strong style="background-color: var(--coral-red-color);" class="rounded-2 text-white p-2">{{
                  pay_reference }}</strong>
              </div>
            </div>
            <div v-if="booking_data.payStatusId != 1 && status_detail != 3"
              :class="['alert', countdownExpired && booking_data.payable ? 'alert-danger' : 'alert-warning', 'text-center']">
              <span v-if="countdownExpired && booking_data.payable">{{ $t("reservation_expired") }}: {{ expiresAtDisplay
              }}</span>
              <span v-if="!countdownExpired">{{ booking_data.message_payable }}</span>
              <strong v-if="booking_data.payable && !countdownExpired">{{ $t("expires_in") }}: {{ countdownDisplay
              }}</strong>
            </div>

            <div class="tour_details_right_sidebar_wrapper">
              <div class="tour_detail_right_sidebar">
                <div class="tour_details_right_boxed">
                  <div class="tour_details_right_box_heading">
                    <h3 class="text-center">{{ $t("booking_details_to_trip") }}</h3>
                  </div>
                  <div class="tour_booking_amount_area">
                    <ul>
                      <li>
                        {{ $t("accommodation") }}
                        <span>
                          {{ booking_data.propertyName }}
                        </span>
                      </li>
                      <li>
                        {{ $t("check_in") }}
                        <span>
                          {{ new Date(booking_data.dates.from).toLocaleDateString('es-ES', {
                            day: '2-digit', month:
                              '2-digit', year: 'numeric'
                          }) }}
                        </span>
                      </li>
                      <li>
                        {{ $t("check_out") }}
                        <span>
                          {{ new Date(booking_data.dates.to).toLocaleDateString('es-ES', {
                            day: '2-digit', month:
                              '2-digit', year: 'numeric'
                          }) }}
                        </span>
                      </li>
                      <li>
                        {{ $t("guests") }}
                        <span>
                          {{ booking_data.rooms[0].searchedPax.adults }}
                          {{ $t("adults") }}
                          <template
                            v-if="Array.isArray(booking_data.rooms[0].searchedPax.children) ? booking_data.rooms[0].searchedPax.children.length > 0 : booking_data.rooms[0].searchedPax.children > 0">,
                            {{ $t("children") }}
                            {{ Array.isArray(booking_data.rooms[0].searchedPax.children) ?
                              booking_data.rooms[0].searchedPax.children.length :
                              booking_data.rooms[0].searchedPax.children }}
                          </template>
                        </span>
                      </li>
                      <li>
                        {{ $t("stay_nights", { count: diffInDays }) }}
                        <span>
                          {{ booking_data.rooms[0].expectedPrice.currency }}
                          {{
                            totalAmount.toLocaleString("es-ES", {
                              minimumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </li>
                    </ul>
                    <div class="tour_bokking_subtotal_area">
                      <h6>
                        {{ $t("subtotal") }}
                        <span>
                          {{
                            booking_data.rooms?.length > 0
                              ? booking_data.rooms[0].expectedPrice.currency
                              : ""
                          }}
                          {{
                            totalAmount.toLocaleString("es-ES", {
                              minimumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </h6>
                    </div>
                    <div class="total_subtotal_booking">
                      <h6>
                        {{ $t("total_amount") }}
                        <span>
                          {{
                            booking_data.rooms.length > 0
                              ? booking_data.rooms[0].expectedPrice.currency
                              : ""
                          }}
                          {{
                            totalAmount.toLocaleString("es-ES", {
                              minimumFractionDigits: 2,
                            })
                          }}
                        </span>
                      </h6>
                      <sub>{{ $t("taxes_included") }}</sub>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tour_details_right_sidebar_wrapper">
              <div class="tour_detail_right_sidebar">
                <div class="tour_details_right_boxed">
                  <div class="tour_details_right_box_heading">
                    <h3 class="text-center">{{ $t("your_information") }}</h3>
                  </div>
                  <div class="tour_booking_amount_area">
                    <ul>
                      <li>
                        {{ $t("name_") }}
                        <span>
                          {{ booking_data.leadGuest.name.first }} {{ booking_data.leadGuest.name.last }}
                        </span>
                      </li>
                      <li>
                        {{ $t("email_") }}
                        <span>
                          {{ booking_data.leadGuest.contact.email }}
                        </span>
                      </li>
                      <li>
                        {{ $t("address_") }}
                        <span>
                          {{ booking_data.leadGuest.contact.address }}
                        </span>
                      </li>
                      <li>
                        {{ $t("country_") }}
                        <span>
                          {{ booking_data.leadGuest.contact.country }}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="(pay_link && booking_data.payable && booking_data.payStatusId != 1) && status_detail != 3"
            class="booking_tour_form_submit text-center">
            <button @click="openPaymentModal" class="btn btn_theme btn_md">
              {{ $t("pay_button") }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="loading">
      <div class="mx-auto d-flex flex-column align-items-center">
        <div class="alert alert-warning text-center">{{ $t("error_get_reservation") }}</div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import { API_BASE_URL, DATA_BOOKING } from "@/api-config";
import Swal from "sweetalert2";


export default {
  name: "TourBooking",
  data() {
    return {
      image: "cancel",
      pay_reference: "",
      pay_link: null,
      paymentMessage: "",
      booking_data: {
        leadGuest: {
          contact: {
            email: "",
            address: "",
            city: "",
            state: "",
            zip: "",
            country: "",
          },
          name: {
            first: "",
            last: "",
          },
        },
        rooms: [
          {
            roomId: 0,
            roomName: "",
            rateCode: "",
            expectedPrice: {
              searchCurrency: 0,
              currency: "",
              comission: 0,
              total: 0,
              amount: 0,
              amount: 0,
              discount: 0,
              promotion: [],
              data: "",
            },
            guests: [
              {
                birthDate: "",
                name: { first: "", last: "" },
              },
            ],
            specialRequests: [],
          },
        ],
      },
      diffInDays: 0,
      isDataLoaded: false,
      _countdownInterval: null,
      now: new Date(),
      status_detail: 0,
    };
  },
  watch: {
    booking_data: {
      handler(newVal) {
        if (newVal?.dates?.from && newVal?.dates?.to) {
          this.calculateDiffInDays();
          this.isDataLoaded = true;
        }
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    this.pay_reference = this.$route.query.pay_reference;

    this.getDataReservation();

    this.paymentCheckout = new PaymentCheckout.modal({
      client_app_code: process.env.VUE_APP_CLIENT_APP_CODE,
      client_app_key: process.env.VUE_APP_CLIENT_APP_KEY,
      locale: process.env.VUE_APP_LOCALE,
      env_mode: process.env.VUE_APP_ENV_MODE,
      onOpen: () => {
        this.hideLoading();
      },
      onClose: () => {
        this.hideLoading();
      },
      onResponse: (response) => {
        this.handlePaymentResponse(response);
      },
    });

  },
  computed: {
    selectedCountry() { },

    totalAmount() {
      return this.booking_data.rooms.reduce((total, room) => {
        return (total += room.expectedPrice.total);
      }, 0);
    },

    totalTaxesDisplayAmount() {
      if (Array.isArray(this.rooms)) {
        return this.booking_data.rooms.reduce((total, room) => {
          return total + room.totalTaxesDisplay;
        }, 0);
      }
      return 0;
    },
    countdownDisplay() {
      if (!this.booking_data.__expiresAt || this.booking_data.is_expired) return "";
      const expiresAt = new Date(this.booking_data.__expiresAt);
      const now = this.now;
      let diff = Math.max(0, Math.floor((expiresAt - now) / 1000));
      const hours = Math.floor(diff / 3600);
      diff %= 3600;
      const minutes = Math.floor(diff / 60);
      const seconds = diff % 60;
      if (hours === 0 && minutes === 0 && seconds === 0) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
      return `${hours.toString().padStart(2, "0")}H ${minutes
        .toString()
        .padStart(2, "0")}m ${seconds.toString().padStart(2, "0")}s`;
    },

    countdownExpired() {
      if (!this.booking_data.__expiresAt) return false;
      return new Date() > new Date(this.booking_data.__expiresAt);
    },

    expiresAtDisplay() {
      if (!this.booking_data.__expiresAt) return "";
      const expiresAt = new Date(this.booking_data.__expiresAt);
      return expiresAt.toLocaleString("es-ES", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },
  },

  methods: {
    getDataReservation() {
      axios
        .post(`${API_BASE_URL}${DATA_BOOKING}${this.pay_reference}`)
        .then((response) => {
          this.booking_data = response.data.data;
          this.pay_link = response.data.data.payLink;
          if (!this.booking_data.is_expired) this.image = "right";
          this.startCountdown();
        })
        .catch((error) => {
          console.log(error);
        });
    },

    hideLoading() {
      Swal.close();
    },
    showLoading() {
      Swal.fire({
        title: 'Cargando...',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
    },

    startCountdown() {
      if (this._countdownInterval) clearInterval(this._countdownInterval);

      this._countdownInterval = setInterval(() => {
        this.now = new Date();
        if (this.countdownExpired && !this.booking_data.is_expired) {
          clearInterval(this._countdownInterval);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        }
      }, 1000);
    },

    openPaymentModal() {
      this.showLoading();
      fetch(this.pay_link, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(JSON.stringify(errorData));
          }
          return response.json();
        })
        .then((data) => {
          this.paymentCheckout.open(data.value);
        })
        .catch((error) => {
          let errorData;
          try {
            errorData = JSON.parse(error.message);
          } catch (e) {
            errorData = error.message;
          }
          Swal.fire({
            title: "Error",
            text: errorData.message || this.$t("error"),
            icon: "error",
          });
          this.paymentCheckout.close();
        })

      window.addEventListener("popstate", () => {
        this.paymentCheckout.close();
      });
    },
    handlePaymentResponse(response) {
      const { status, status_detail } = response.transaction;

      this.status_detail = status_detail;
      console.log("This.status_detail:", this.status_detail);
      if (status === "success" && status_detail === 3) {
        this.paymentMessage = this.$t("payment_approved");
      } else if (status === "failure" && status_detail === 9) {
        this.paymentMessage = this.$t("payment_rejected");
      } else if (status === "pending" && status_detail === 1) {
        this.paymentMessage = this.$t("payment_under_review");
      } else if (status === "failure" && status_detail === 11) {
        this.paymentMessage = this.$t("payment_antifraud_rejected");
      } else if (status === "failure" && status_detail === 12) {
        this.paymentMessage = this.$t("payment_blacklist");
      } else {
        this.paymentMessage = "Unknown status";
      }
    },

    calculateDiffInDays() {
      const fromDate = new Date(this.booking_data.dates.from);
      const toDate = new Date(this.booking_data.dates.to);
      const diff = (toDate - fromDate) / (1000 * 3600 * 24);
      this.diffInDays = Math.round(diff);
    }

  },
};
</script>
